export class CookieUtils {

    private static parseDocumentCookie() {
        return document.cookie.split(';').map((cookieStr) => {
            return cookieStr.trim().split('=').map(decodeURIComponent);
        }).reduce((cookieObj, cookieKeyValPair) => {
            try {
                cookieObj[cookieKeyValPair[0]] = JSON.parse(cookieKeyValPair[1]);
            } catch (e) {
                cookieObj[cookieKeyValPair[0]] = cookieKeyValPair[1];
            }
            return cookieObj;
        }, {});
    }

    public static readCookie(name) {
        const cookieObj = CookieUtils.parseDocumentCookie();
        return cookieObj[name];
    };

    public static deleteCookie(name) {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    }
    public static getCookie = (name) => {
        if (typeof window !== "undefined") {
          const value = `; ${window.document.cookie}`;
          const parts = value.split(`; ${name}=`);
          return parts.length >= 2 ? parts.pop().split(";").shift() : "";
        } else {
          return "";
        }
      };
}